// Common error-code i18n runtime surface.
//
// Every app needs the unknown-code template plus the cross-domain leftovers.
// Business error-code dictionaries live in per-domain namespaces
// (`./i18n/features/<locale>/error-code-<domain>.ts`). App transports attach the
// one domain they own through `attachErrorCodeDomain`; the shared error helpers
// call the accessors below, so attaching always takes effect and an app bundle
// only contains the error codes it renders.

import { errorCodeCommon as enErrorCodeCommon } from "./i18n/features/en/error-code-common";
import { errorCodeCommon as jaErrorCodeCommon } from "./i18n/features/ja/error-code-common";
import { errorCodeCommon as zhErrorCodeCommon } from "./i18n/features/zh/error-code-common";
import {
  attachErrorCodeDomain,
  registerErrorCodeCommonLocale,
} from "./i18n-error-code-common-runtime";

registerErrorCodeCommonLocale("zh-CN", zhErrorCodeCommon);
registerErrorCodeCommonLocale("en", enErrorCodeCommon);
registerErrorCodeCommonLocale("ja", jaErrorCodeCommon);

export * from "./i18n-error-code-common-runtime";

// Keep the legacy entrypoint's all-locale registration contract explicit.
export { attachErrorCodeDomain };
